import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Title as TitleBase } from '../../styled'
import { SliderCostume } from './slider-costume'
import { CostumeAnimation } from './costume-animation'
import { Title } from './styled'

export const Costume = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <TextContainer>
      <TitleBase data-menu-title="татарский костюм">Татарский костюм</TitleBase>
    </TextContainer>
    <CostumeAnimation />
    <TextContainer>
      <Title>Украшения</Title>
      <p>
        Татарские мастера славились ювелирным искусством. Многие украшения
        выполнялись в технике ажурной филиграни.
      </p>
    </TextContainer>
    <SliderCostume />
  </section>
))
